import React, { Component } from "react";
import Utils from "../Utils/Helpers";


class TYUpload extends Component{
    constructor(props){
        super(props);

        this.state = {
            error: null,
            isOver: false,
            img_base_64: null,
            position: [0, 0],
            scale: 1,
            canvasClick: {
                position: [0, 0],
                held: false
            },
            displayZoomSlider: Utils.isMobile()
        };

        this.addCanvasListener = this.addCanvasListener.bind(this);
        this.removeCanvasListener = this.removeCanvasListener.bind(this);
        this.removeListeners = this.removeListeners.bind(this);
        this.addListeners = this.addListeners.bind(this);
        this._onDragEnter = this._onDragEnter.bind(this);
        this._onDragLeave = this._onDragLeave.bind(this);
        this._onDragOver = this._onDragOver.bind(this);
        this._onDrop = this._onDrop.bind(this);
        this._canvasMouseDown = this._canvasMouseDown.bind(this);
        this._canvasMouseUp = this._canvasMouseUp.bind(this);
        this._canvasMouseMove = this._canvasMouseMove.bind(this);
        this._canvasMouseWheel = this._canvasMouseWheel.bind(this);
        this.drawImgInCanvas = this.drawImgInCanvas.bind(this);
        this.getImageData = this.getImageData.bind(this);
        this.updateZoomFromSlider = this.updateZoomFromSlider.bind(this);
        this.zoomOut = this.zoomOut.bind(this);
        this.zoomIn = this.zoomIn.bind(this);
    }
  
    componentWillUnmount() {
        if(this.state.img_base_64)
            this.removeCanvasListener();
        else
            this.removeListeners();
    }

    componentDidMount() {
        this.addListeners();
    }

    removeListeners(){
        this.refs.dragbox.removeEventListener('mouseup', this._onDragLeave);
        this.refs.dragbox.removeEventListener('dragenter', this._onDragEnter);
        this.refs.dragbox.removeEventListener('dragover', this._onDragOver);
        this.refs.dragbox.removeEventListener('dragleave', this._onDragLeave);
        this.refs.dragbox.removeEventListener('drop', this._onDrop);
    }

    addListeners(){
        this.refs.dragbox.addEventListener('mouseup', this._onDragLeave);
        this.refs.dragbox.addEventListener('dragenter', this._onDragEnter);
        this.refs.dragbox.addEventListener('dragover', this._onDragOver);
        this.refs.dragbox.addEventListener('drop', this._onDrop);
        this.refs.dragbox.addEventListener('dragleave', this._onDragLeave);
    }
    
    addCanvasListener(){
        this.refs.canvas.addEventListener("mousedown", this._canvasMouseDown);
        this.refs.canvas.addEventListener("mouseup", this._canvasMouseUp);
        this.refs.canvas.addEventListener("mousemove", this._canvasMouseMove);
        this.refs.canvas.addEventListener("mousewheel", this._canvasMouseWheel);
        this.refs.canvas.addEventListener("DOMMouseScroll", this._canvasMouseWheel);
    }
    
    removeCanvasListener(){
        this.refs.canvas.removeEventListener("mousedown", this._canvasMouseDown);
        this.refs.canvas.removeEventListener("mouseup", this._canvasMouseUp);
        this.refs.canvas.removeEventListener("mousemove", this._canvasMouseMove);
        this.refs.canvas.removeEventListener("mousewheel", this._canvasMouseWheel);
        this.refs.canvas.removeEventListener("DOMMouseScroll", this._canvasMouseWheel);
    }

    drawImgInCanvas(){
        let context = this.refs.canvas.getContext("2d");
        
        context.webkitImageSmoothingEnabled = false;
        context.mozImageSmoothingEnabled = false;
        context.imageSmoothingEnabled = false; 

        let img = new Image();
        img.onload = () => {
            context.clearRect(0, 0, this.refs.canvas.width, this.refs.canvas.height);
            
            context.beginPath();
            context.rect(0, 0, this.refs.canvas.width, this.refs.canvas.height);
            context.fillStyle = this.props.canvasBg;
            context.fill();
            
            context.save();
            context.scale(this.state.scale, this.state.scale);
            context.drawImage(img, this.state.position[0], this.state.position[1]);
            context.restore();
        };
        img.src = this.state.img_base_64;
    }

    _canvasMouseMove(e){
        if(this.state.canvasClick.held){
            let mX = e.movementX / this.state.scale;
            let mY = e.movementY / this.state.scale;

            this.setState({
                position: [this.state.position[0] + mX, this.state.position[1] + mY],
                canvasClick:{
                    held: true,
                    position: [e.layerX, e.layerY]
                }
            }, () => this.drawImgInCanvas());
        }
    }

    _canvasMouseUp(){
        this.setState({canvasClick: {
            position: [0, 0],
            held: false
        }});
    }

    _canvasMouseDown(e){
        this.setState({canvasClick: {
            position: [e.layerX, e.layerY],
            held: true
        }});
    }

    _canvasMouseWheel(e){
        if (e.preventDefault)
            e.preventDefault();
        let d = e.wheelDelta || e.originalEvent.detail*-1;
        let scale = this.state.scale + (d/120 > 0 ? 0.01 : - 0.01);
        if(scale > 0){
            this.setState({
                scale: scale
            }, this.drawImgInCanvas);
        }
    }
    
    _onDragEnter(e) {
        this.setState({ error: false, isOver: true });
        e.stopPropagation();
        e.preventDefault();
        return false;
    }
    
    _onDragOver(e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
    }
    
    _onDragLeave(e) {
        this.setState({ error: false, isOver: false });
        e.stopPropagation();
        e.preventDefault();
        return false;
    }
    
    _onDrop(e) {
        e.preventDefault();
        let files = e.target.files || e.dataTransfer.files;
        this.setState({ error: false, isOver: false });

        if(!files || !files.length)
            return;
        else if(files[0]["size"] > this.props.maxSize*1000){
            this.setState({error: "Fichier trop volumineux, max: " + this.props.maxSize + "Ko"});
            return;
        }

        // File type check
        let type = files[0]["type"];
        if(type.split("/")[0] != "image"){
            this.setState({error: "Fichier non autorisé"});
            return;
        }

        let addListener = true;
        if(!this.state.img_base_64)
            this.removeListeners();
        else
            addListener = false;
        
        // Upload files
        var reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = () => {
            this.setState({img_base_64: reader.result}, () => {
                if(addListener)
                    this.addCanvasListener();
                this.drawImgInCanvas();
            });
        };

        return false;
    }

    getImageData(){
        return this.refs.canvas.toDataURL();
    }

    updateZoomFromSlider(event){
        this.setState({
            scale: parseFloat(event.target.value)
        },  this.drawImgInCanvas);
    }

    zoomOut(){
        this.setState({scale: this.state.scale - 0.02}, this.drawImgInCanvas)
    }

    zoomIn(){
        this.setState({scale: this.state.scale + 0.02}, this.drawImgInCanvas)
    }

    render(){
        return (
            <div className={
                "dropzone-container " + " _h-" + this.props.zoneHeight + " _w-" + this.props.zoneWidth
                 + (this.state.isOver ? " file-hover " : "")
                 + (this.state.error ? " error " : "") 
                 + (this.state.img_base_64 ? " with-canvas" : "")
            }>
                <input type="file" ref="file_upload" style={{display: "none"}} onChange={this._onDrop} />

                <table className="w-100 h-100">
                    <tbody>
                    {
                        !this.state.img_base_64 ?
                            <tr>
                                <td className="relative center">
                                    { this.props.children }
                                    {
                                        this.state.error ? 
                                            <div className="red f-12 marg-t-15">{this.state.error}</div>
                                            :
                                            ""
                                    }
                                    <div 
                                        ref="dragbox" 
                                        className={"dropzone-zone top-0 left-0 absolute " + " _h-" + this.props.zoneHeight + " _w-" + this.props.zoneWidth}
                                        onClick={() => {this.refs.file_upload.click();}}>

                                    </div>
                                </td>
                            </tr>
                            :
                            null
                    }
                    {
                        this.state.img_base_64 ? 
                            <tr>
                                <td className="overflow-hidden bg-gray_light pad-0 marg-0 relative"
                                    onMouseEnter={() => this.setState({displayZoomSlider: true})}
                                    onMouseLeave={() => this.setState({displayZoomSlider: Utils.isMobile()})}
                                >
                                    <canvas 
                                        width={this.props.width} 
                                        height={this.props.height} 
                                        ref="canvas"
                                    >
                                    </canvas>

                                    {
                                        this.state.displayZoomSlider ?
                                            <div style={{cursor: "pointer"}}>
                                                <span className="absolute left-0 bottomp-14 lh-15 cursor pad-5 disable-text-selection" style={{bottom: "11.5%"}}
                                                      onClick={this.zoomOut}
                                                >- </span>
                                                <input
                                                    value={this.state.scale}
                                                    className="ty-uploader-zoom-slider"
                                                    onChange={this.updateZoomFromSlider}
                                                    type="range"
                                                    min="0"
                                                    max="2"
                                                    step="0.0000000001"
                                                />
                                                <span className="absolute right-0 lh-15 cursor pad-5 disable-text-selection" style={{bottom: "10.5%"}}
                                                      onClick={this.zoomIn}
                                                >&nbsp;+</span>
                                            </div>
                                            : ""
                                    }
                                </td>
                            </tr>
                            : 
                            null
                    }
                    </tbody>
                </table>
            </div>
        );
    }
}

TYUpload.defaultProps = {
    zoneHeight: 200,
    zoneWidth: 200,
    width: 200,
    height: 200,
    maxSize: 200,
    canvasBg: "white"
};

export default TYUpload;


// WEBPACK FOOTER //
// ./src/components/TYUpload.js